export { default as managedItServices } from "./managedItServices.svg"
export { default as managedNetwork } from "./managedNetwork.svg"
export { default as voiceandmobility } from "./voiceandmobility.svg"
export { default as cloudServices } from "./cloudServices.svg"
export { default as collabration } from "./collabration.svg"
export { default as cyberSecurity } from "./cyberSecurity.svg"
export { default as digitalWorkplace } from "./digitalWorkplace.svg"
export { default as internet } from "./internet.svg"
export { default as itProcurement } from "./itProcurement.svg"
